import {
  getCookie,
  setCookie,
  deleteCookie,
} from "../../../resources/js/helper/helper";

(function () {
  /**
   * Enable youtube video
   */
  const videoGates = document.querySelectorAll(".mb-enable-video");

  for (let i = 0; i < videoGates.length; i++) {
    videoGates[i].addEventListener("click", () => {
      setCookie("youtube_privacy_cookie", true, 365);
      location.reload();

      // for each single video
      // let privacyCookie = getCookie("youtube_privacy_cookie");
      // privacyCookie = privacyCookie ? privacyCookie.split(" ") : [];
      // const videoID = videoGates[i].dataset.videoId;

      // if (videoID && !privacyCookie.includes(videoID)) {
      //   privacyCookie.push(videoID);
      //   setCookie("youtube_privacy_cookie", privacyCookie.join(" "), 365);
      //   location.reload();
      // }
    });
  }

  /**
   * Disable all youtube integrations
   */
  const resetAllGates = document.querySelectorAll(".mb-disable-youtube");

  for (let i = 0; i < resetAllGates.length; i++) {
    resetAllGates[i].addEventListener("click", () => {
      deleteCookie("youtube_privacy_cookie");
      location.reload();
    });
  }

  /**
   * Show / Hide controls from html-player on hover
   */
  const videoFileComponents = document.querySelectorAll(".com-video video");
  for (let i = 0; i < videoFileComponents.length; i++) {
    const video = videoFileComponents[i];
    video.removeAttribute("controls");

    video.addEventListener("mouseover", function () {
      video.setAttribute("controls", "controls");
    });

    video.addEventListener("mouseout", function () {
      video.removeAttribute("controls");
    });
  }
})();
